var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 41,
    viewBox: "0 0 32 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9505 27.651L25.3001 16.3014L22.3505 13.3518L13.9001 21.8022L9.70007 17.5518L6.75047 20.5014L13.9505 27.651ZM16.0001 40.5006C11.3665 39.3678 7.54167 36.7262 4.52567 32.5758C1.50807 28.427 -0.000732422 23.819 -0.000732422 18.7518V6.4518L16.0001 0.502197L32.0009 6.4518V18.7518C32.0009 23.819 30.4921 28.427 27.4745 32.5758C24.4585 36.7262 20.6337 39.3678 16.0001 40.5006ZM16.0001 36.051C19.4001 34.9838 22.2169 32.8254 24.4505 29.5758C26.6841 26.3262 27.8009 22.7182 27.8009 18.7518V9.351L16.0001 4.9518L4.19927 9.351V18.7518C4.19927 22.7182 5.30807 26.3262 7.52567 29.5758C9.74167 32.8254 12.5665 34.9838 16.0001 36.051Z",
    fill: "#0CBC08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedUser);
export default __webpack_public_path__ + "static/media/verifiedUser.9b88615749cbe96b2fcaf791feb9831c.svg";
export { ForwardRef as ReactComponent };